import defaultAvatarImg from '../assets/avatar-default.png';

/** Default avatar image. Use avatarUrl when available (future: from DB). */
export function DefaultAvatar({
  avatarUrl,
  className = '',
}: {
  avatarUrl?: string | null;
  className?: string;
}) {
  const src = avatarUrl ?? defaultAvatarImg;
  return (
    <img
      src={src}
      alt=""
      className={`object-cover rounded-full ${className}`}
    />
  );
}
